/* SC bird search typing effect. Types bird names into the placeholder of every bird species search
   field: desktop and mobile menus, quiz, bundle builder, bird finder, breed pickers (cart drawer,
   contact, giveaway). Settings: Theme settings > Bird search typing (snippets/sc-bird-typewriter.liquid).
   - "Type a bird, e.g. galah": keeps "Type a bird, e.g. " and types the bird.
   - Any other placeholder: types birds, then returns to the original text every third word.
   - Stops and shows the original text on focus. Waits while the field has a value.
   - Runs only while the field is on screen. Off for reduced motion.
   - Add a field: data-sc-typewriter. Skip a field: data-sc-typewriter="off". */
(function () {
  'use strict';
  if (window.__scTw) return;
  window.__scTw = true;

  var cfg = window.SC_TW || {};
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if ((rm && rm.matches) || !('IntersectionObserver' in window)) return;

  var SEL = '[data-dm-find-q],[data-mm2-bird-q],input[id^="bq4q-"],[data-scpc-matcher-input],.quick-search-input,[data-sc-breed-input],[data-sc-typewriter]';
  var WORDS = String(cfg.words || 'galah, cockatiel, budgie, rainbow lorikeet, lovebird, cockatoo, eclectus, conure, African grey, ringneck')
    .split(',').map(function (w) { return w.trim(); }).filter(Boolean);
  if (!WORDS.length) return;
  var TYPE = Math.max(20, +cfg.type || 75);
  var HOLD = Math.max(400, +cfg.hold || 1600);
  var DEL = 32;
  var START = 1400;
  var count = 0;

  function cap(w) { return w.charAt(0).toUpperCase() + w.slice(1); }

  function parse(st) {
    var m = /^(.*\be\.g\.\s*)(.*)$/i.exec(st.base);
    st.eg = !!m;
    st.pre = m ? m[1] : '';
    st.cur = m ? m[2] : st.base;
    st.upper = !m || /^[A-Z]/.test(st.cur);
  }

  function write(st, txt) {
    st.text = txt;
    st.last = st.pre + txt;
    st.el.setAttribute('placeholder', st.last);
  }

  function reset(st) {
    clearTimeout(st.t);
    st.phase = 'hold';
    if (st.el.getAttribute('placeholder') !== st.last) { st.base = st.el.getAttribute('placeholder') || ''; parse(st); }
    write(st, st.cur);
  }

  function later(st, ms) { clearTimeout(st.t); st.t = setTimeout(function () { step(st); }, ms); }

  function start(st, ms) {
    if (!st.vis || document.activeElement === st.el) return;
    reset(st);
    later(st, ms);
  }

  function shown(el) {
    return el.offsetWidth > 0 && getComputedStyle(el).visibility !== 'hidden';
  }

  function next(st) {
    st.n++;
    if (!st.eg && st.n % 3 === 0) return st.cur; /* back to the original text */
    var w, tries = 0;
    do { w = WORDS[st.w++ % WORDS.length]; tries++; } while (w.toLowerCase() === st.prev.toLowerCase() && tries < WORDS.length);
    return st.upper ? cap(w) : w;
  }

  function step(st) {
    var el = st.el;
    if (!el.isConnected) { clearTimeout(st.t); io.unobserve(el); el.__scTw = null; return; }
    if (!st.vis || document.activeElement === el) return;
    if (el.value || !shown(el)) { reset(st); later(st, 2500); return; }
    if (el.getAttribute('placeholder') !== st.last) { reset(st); later(st, HOLD); return; } /* another script changed it */

    if (st.phase === 'hold') { st.prev = st.text; st.phase = 'del'; later(st, DEL); return; }
    if (st.phase === 'del') {
      if (st.text.length) { write(st, st.text.slice(0, -1)); later(st, DEL); return; }
      st.target = next(st);
      st.phase = 'type';
      later(st, TYPE * 2);
      return;
    }
    if (st.text.length < st.target.length) {
      write(st, st.target.slice(0, st.text.length + 1));
      later(st, TYPE + Math.round(Math.random() * TYPE * 0.6));
      return;
    }
    st.phase = 'hold';
    later(st, st.target === st.cur && !st.eg ? HOLD * 2 : HOLD);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var st = e.target.__scTw;
      if (!st) return;
      st.vis = e.isIntersecting;
      if (st.vis) start(st, START);
      else reset(st);
    });
  });

  function add(el) {
    if (el.__scTw || el.tagName !== 'INPUT' || el.disabled || el.readOnly) return;
    if (el.getAttribute('data-sc-typewriter') === 'off') return;
    var ph = el.getAttribute('placeholder');
    if (!ph) return;
    var st = { el: el, base: ph, last: ph, text: '', prev: '', target: '', phase: 'hold', n: 0, w: count++ * 3, vis: false, t: 0 };
    parse(st);
    st.text = st.cur;
    if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby') && !(el.labels && el.labels.length)) {
      el.setAttribute('aria-label', ph); /* keep a fixed accessible name while the placeholder moves */
    }
    el.__scTw = st;
    io.observe(el);
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll(SEL), add); }

  document.addEventListener('focusin', function (e) {
    var st = e.target && e.target.__scTw;
    if (st) reset(st);
  });
  document.addEventListener('focusout', function (e) {
    var st = e.target && e.target.__scTw;
    if (st) start(st, START);
  });

  /* Fields added later: desktop menu mount, quiz steps, cart drawer refresh */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 400);
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan();
})();
